import React from "react"
import Slider from "react-slick"
import styled from "styled-components"
const TargetSlid = ({ targetWords, lang }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  return (
    <Slider {...settings}>
      {targetWords.map((word, index) => (
        <Div className="targetsInfoSection" key={index}>
          <img
            src={word.icon}
            alt="target icon"
            className="aboutPageLogo icon"
          />
          <h3 className="aboutPageTitle">{word[lang].title}</h3>

          <p className="noLine">{word[lang].desc}</p>
        </Div>
      ))}
    </Slider>
  )
}

export default TargetSlid

const Div = styled.div`
  margin-top: 20px;
  border: 1px solid black;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
  margin-top: 65px;
  width: 60vw !important;
  padding: 5px 0px;
  .noLine {
    min-height: 125px;
  }
  .aboutPageLogo {
    margin: -68px auto 0 auto;
  }
`
